import React from 'react';
import PropTypes from 'prop-types';
import { ParentSpaceProvider, SubspaceProvider } from 'react-redux-subspace';
import values from 'lodash/values';
import get from 'lodash/get';
import MainTabs from '@skunexus/fulfillment-main-tabs';

import { filterAccessibleItems } from '../../../../utils';
import app from '../../../../config';

function MainTabsLayout({ children, name, ...props }) {
    const mainTabsParamsConfig = get(app.general.getItem('modules'), 'fulfillment.mainTabsParamsConfig', {});
    return (
        <div>
            <ParentSpaceProvider>
                <SubspaceProvider
                    mapState={(state) => ({
                        ...state.fulfillmentMainTabs,
                        ...state[name],
                    })}
                >
                    <>
                        <MainTabs
                            states={filterAccessibleItems(values(app.interOfficeTabs.getAll()))}
                            {...mainTabsParamsConfig}
                            {...props}
                        />
                        {children}
                    </>
                </SubspaceProvider>
            </ParentSpaceProvider>
        </div>
    );
}

MainTabsLayout.propTypes = {
    children: PropTypes.any,
    name: PropTypes.string.isRequired,
};
MainTabsLayout.defaultProps = {
    children: null,
};

export default MainTabsLayout;
